/**
 * The address a new listing starts with. The store address comes first because
 * that is where it ships from; `is_default` only says what checkout fills in.
 */
export const preferredListingAddress = (addresses = []) =>
  addresses.find((a) => a.is_store_address) || addresses.find((a) => a.is_default) || addresses[0];
